import { useLabels } from '../../i18n/labels';

interface StatusBadgeProps {
  status: string;
  className?: string;
}

/** The badge of a request status (#661): the colour is here, the text is
 *  `requestStatusLabel()`, so it follows the language of the page. */
export default function StatusBadge({ status, className = '' }: StatusBadgeProps) {
  const { requestStatusLabel } = useLabels();
  const color = status === 'approved' ? 'badge-green'
    : status === 'rejected' ? 'badge-gray'
    : 'badge-amber';
  return (
    <span className={`badge text-xs ${color} ${className}`}>
      {requestStatusLabel(status)}
    </span>
  );
}
